// extracted by mini-css-extract-plugin
var _1 = "UpgradeThanks_desktopTitle__FKysx";
var _2 = "UpgradeThanks_image__zeHBX";
var _3 = "UpgradeThanks_imageContainer__Ex4QG";
var _4 = "UpgradeThanks_messageContainer__DuL+1";
var _5 = "UpgradeThanks_mobileTitle__NQGHu";
var _6 = "UpgradeThanks_submitButton__u8fF0";
var _7 = "UpgradeThanks_upgradeThanks__1zXHG";
export { _1 as "desktopTitle", _2 as "image", _3 as "imageContainer", _4 as "messageContainer", _5 as "mobileTitle", _6 as "submitButton", _7 as "upgradeThanks" }
